import debug from "debug";

const log = debug("app:image");

/**
 * Handles the calculation of sizes and dimensions for the Title Block based on HTML elements.
 * @category Components
 * @subcategory TitleBlock
 */
export class TitleBlockSizes {
  /**
   * Constructs a new instance of TitleBlockSizes.
   * @param {Object} experience - The shared application context containing DOM references and other data.
   */
  constructor(experience) {
    this.experience = experience;
    this.headerElement = document.getElementById("catHeader");
    this.footerElement = document.getElementById("footerContainer");
    this.canvas = document.getElementById("modelCanvas");
    this.ratio = 11 / 8.5; // Ratio for the borders
  }

  cleanup() {
    console.log("✅ Cleaning up TitleBlockSizes...");

    // Nullify DOM element references to prevent memory leaks
    this.headerElement = null;
    this.footerElement = null;
    this.canvas = null;

    console.log("✅ TitleBlockSizes cleanup complete.");
}

  /**
   * Calculates the sizes of the Title Block based on the header, footer, and canvas dimensions.
   * @returns {Object|null} An object containing the calculated dimensions:
   * - {number} height - The calculated height of the Title Block.
   * - {number} width - The calculated width of the Title Block.
   * - {number} top - The top offset based on the header height.
   * - {number} bottom - The bottom offset based on the footer height.
   * Returns `null` if the header or footer elements are not found.
   */
  htmlElementSizes() {
    if (this.headerElement && this.footerElement) {
      const headerRect = this.headerElement.getBoundingClientRect();
      const footerRect = this.footerElement.getBoundingClientRect();
      const canvasRect = this.canvas.getBoundingClientRect();

      // Use canvas dimensions instead of window
      const top = headerRect.height;
      const bottom = footerRect.height;
      const height = canvasRect.height - headerRect.height - footerRect.height;
      const width = height * this.ratio;

      log("canvasRect", canvasRect);
      log(`
        canvas width ${this.canvas.clientWidth}
        width ${width}
        canvas height ${this.canvas.clientHeight}
        height ${height}
        top ${top}
        bottom ${bottom}
        `);
      // sizes of the TitleBlock
      return {
        height: height,
        width: width,
        top: top,
        bottom: bottom,
      };
    }

    return null; // In case header or footer elements are not found
  }
}
